import React, { FC } from 'react'
import { Badge, BadgeProps } from '@chakra-ui/react'
import { useTranslations } from "next-intl";

interface ProductBadgeProps extends BadgeProps {
  type?: 'sale' | 'new' | 'bestseller' | 'limited'
  label?: string
  className?: string
}

const ProductBadge: FC<ProductBadgeProps> = ({
  type = 'default',
  label,
  ...badgeProps
}) => {
  const t = useTranslations()
  const variantProps: BadgeProps = {}
  let defaultLabel = 'product_badge'

  // TODO: Перевести
  switch (type) {
    case 'sale':
      variantProps.backgroundColor = 'accent.red'
      variantProps.color = 'white'
      defaultLabel = 'product_sale'
      break
    case 'new':
      variantProps.backgroundColor = 'brand'
      variantProps.color = 'white'
      defaultLabel = 'product_new'
      break
    case 'bestseller':
      variantProps.colorScheme = 'blue'
      defaultLabel = 'product_bestseller'
      break
    case 'limited':
      variantProps.colorScheme = 'purple'
      defaultLabel = 'product_limited'
      break
    default:
      variantProps.colorScheme = 'gray'
      defaultLabel = 'product_badge'
      break
  }

  return (
    <Badge
      {...variantProps}
      {...badgeProps}
      borderRadius="none"
      textStyle={"regular12"}
      px={2}
      py={1}
      role="status"
      aria-label={label ?? badgeProps['aria-label'] ?? defaultLabel}
    >
      { label ? label : t.has(defaultLabel) ? t(defaultLabel) : defaultLabel}
    </Badge>
  )
}

export default ProductBadge
